import { HttpParams } from '@angular/common/http';
import { FormMetricsFilter } from 'services/models/form-builder/form-metrics/form-metrics-filter.model';

/** Serializes Form Metrics filters using repeated keys for array values. */
export function buildFormMetricsHttpParams(
  filters?: FormMetricsFilter | null,
  extra?: Record<string, string | number | null | undefined>
): HttpParams {
  let params = new HttpParams();

  if (extra) {
    Object.entries(extra).forEach(([key, value]) => {
      if (value === null || value === undefined || value === '') {
        return;
      }
      params = params.set(key, String(value));
    });
  }

  if (!filters) {
    return params;
  }

  if (filters.companyId) {
    params = params.set('companyId', filters.companyId);
  }
  if (filters.period) {
    params = params.set('period', filters.period);
  }
  if (filters.dateBegin) {
    params = params.set('dateBegin', filters.dateBegin);
  }
  if (filters.dateEnd) {
    params = params.set('dateEnd', filters.dateEnd);
  }
  if (filters.trialEndBegin) {
    params = params.set('trialEndBegin', filters.trialEndBegin);
  }
  if (filters.trialEndEnd) {
    params = params.set('trialEndEnd', filters.trialEndEnd);
  }
  if (filters.employeeId) {
    params = params.set('employeeId', filters.employeeId);
  }
  if (filters.period) {
    params = params.set('period', filters.period);
  }
  if (filters.trialEndBegin) {
    params = params.set('trialEndBegin', filters.trialEndBegin);
  }
  if (filters.trialEndEnd) {
    params = params.set('trialEndEnd', filters.trialEndEnd);
  }
  if (filters.costCenterId?.length) {
    filters.costCenterId.forEach(id => {
      if (id) {
        params = params.append('costCenterId', id);
      }
    });
  }
  if (filters.submissionStatus?.length) {
    filters.submissionStatus.forEach(status => {
      if (status) {
        params = params.append('submissionStatus', status);
      }
    });
  }

  return params;
}
